import logo from '../../assets/startuphive.png'
import HeaderActions from './HeaderActions'
import './Layout.css'

function Layout({ children }) {
  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-content">
          <div className="layout-header-brand">
            <img
              src={logo}
              alt="StartupHive Logo"
              className="layout-header-logo"
            />
            <div>
              <h1>StartupHive</h1>
              <p className="layout-header-tagline">Digital Launch Request</p>
            </div>
          </div>
          <HeaderActions />
        </div>
      </header>

      <main className="layout-main">
        {children}
      </main>

      <footer className="layout-footer">
        <div className="container">
          <p>
            &copy; 2025 StartupHive. Making Startups Happy in Japan.
            {' '}<a href="https://startuphive.jp" target="_blank" rel="noopener noreferrer">Visit our website</a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Layout
